import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                高评分电视剧
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              专注汇集最新热门与高评价的电视剧资源，覆盖国产剧、海外剧等多类别，帮助你快速找到值得一看的优质影视内容。
            </p>
            <p className="text-xs text-background-300/80 mt-4">
              本站为影视内容展示与推荐平台，演示数据均为虚构示例，不提供在线播放与下载功能。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#footer-nav" className="cursor-pointer">剧集分类</a>
            </h4>
            <ul className="space-y-2.5" id="footer-nav">
              {navCategories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系与帮助</a>
            </h4>
            <ul className="space-y-2.5" id="footer-contact">
              <li className="text-sm text-background-200">
                <i className="ri-mail-line mr-2 text-accent-400"></i>
                contact@highrated-tv.example
              </li>
              <li className="text-sm text-background-200">
                <i className="ri-time-line mr-2 text-accent-400"></i>
                内容更新：每日 08:00 / 20:00
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  搜索剧集
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300 text-center sm:text-left">
            © {year} 高评分电视剧. 保留所有权利. 备案号：演示备案 0000000 号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-300">
            <span className="cursor-pointer hover:text-accent-400 transition-colors">友情链接</span>
            <span className="cursor-pointer hover:text-accent-400 transition-colors">版权声明</span>
            <span className="cursor-pointer hover:text-accent-400 transition-colors">数据来源</span>
          </div>
        </div>
      </div>
    </footer>
  );
}